<template>
  <v-container fluid class="home">
    <FirstLook/> 
    <HomeGrid/> 
  </v-container>
</template>

<script>
import FirstLook from "./FirstLook.vue";
import HomeGrid from "./HomeGrid.vue";
export default {
  name: "Home",
  components: {
    FirstLook,
    HomeGrid
  }
};
</script>

<style>
.home{
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
}
</style>
